module.exports = __webpack_public_path__ + "img/flower.f2615b88.png";